var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import styled from "styled-components";
import { Query } from "react-apollo";
import { Link, NavLink } from "react-router-dom";
import posed, { PoseGroup } from "react-pose";
import { MEDIA_QUERIES } from "shared/style";
import Loading from "components/shared/Loading";
import Error from "components/shared/Error";
import { GET_HEADER } from "./index";
import User from "./User";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    width: 100%;\n    height: 60px;\n    padding: 10px 0;\n    text-align: center;\n    box-shadow: 0 -3px 10px grey;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background: #fff;\n    z-index: 9999;\n\n    > .logo {\n      height: 40px;\n\n      > a > img {\n        max-height: 40px;\n      }\n    }\n\n    > .menu-btn {\n      position: absolute;\n      top: 22px;\n      right: 10px;\n      width: 20px;\n      height: 16px;\n      cursor: pointer;\n\n      > img {\n        max-width: 100%;\n      }\n    }\n\n    > .dimmed {\n      position: fixed;\n      width: 100%;\n      height: 100vh;\n      top: 0;\n      left: 0;\n    }\n\n    > .menu {\n      position: fixed;\n      top: 0;\n      left: 100%;\n      width: 100%;\n      height: 100vh;\n      overflow: hidden;\n\n      > .area {\n        float: right;\n        width: 50%;\n        height: 100vh;\n        overflow: auto;\n        background: #e0e0e0;\n        box-shadow: 3px 0 10px grey;\n\n        > .x {\n          position: absolute;\n          top: 10px;\n          right: 5px;\n          width: 30px;\n          height: 30px;\n          line-height: 30px;\n          cursor: pointer;\n\n          > img {\n            width: 15px;\n            height: 15px;\n          }\n        }\n\n        > nav {\n          width: 100%;\n          background: #f0f0f0;\n\n          > a {\n            width: 100%;\n            height: 50px;\n            line-height: 50px;\n            display: block;\n            text-align: left;\n            padding-left: 20px;\n            color: #555;\n            font-size: 14px;\n            text-decoration: none;\n          }\n\n          > .active {\n            background: #fff;\n          }\n        }\n\n        > .user {\n          margin-top: 5px;\n        }\n      }\n    }\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n\n  ", " {\n    width: 100%;\n    height: 60px;\n    padding: 10px 0;\n    text-align: center;\n    box-shadow: 0 -3px 10px grey;\n    position: fixed;\n    top: 0;\n    left: 0;\n    background: #fff;\n    z-index: 9999;\n\n    > .logo {\n      height: 40px;\n\n      > a > img {\n        max-height: 40px;\n      }\n    }\n\n    > .menu-btn {\n      position: absolute;\n      top: 22px;\n      right: 10px;\n      width: 20px;\n      height: 16px;\n      cursor: pointer;\n\n      > img {\n        max-width: 100%;\n      }\n    }\n\n    > .dimmed {\n      position: fixed;\n      width: 100%;\n      height: 100vh;\n      top: 0;\n      left: 0;\n    }\n\n    > .menu {\n      position: fixed;\n      top: 0;\n      left: 100%;\n      width: 100%;\n      height: 100vh;\n      overflow: hidden;\n\n      > .area {\n        float: right;\n        width: 50%;\n        height: 100vh;\n        overflow: auto;\n        background: #e0e0e0;\n        box-shadow: 3px 0 10px grey;\n\n        > .x {\n          position: absolute;\n          top: 10px;\n          right: 5px;\n          width: 30px;\n          height: 30px;\n          line-height: 30px;\n          cursor: pointer;\n\n          > img {\n            width: 15px;\n            height: 15px;\n          }\n        }\n\n        > nav {\n          width: 100%;\n          background: #f0f0f0;\n\n          > a {\n            width: 100%;\n            height: 50px;\n            line-height: 50px;\n            display: block;\n            text-align: left;\n            padding-left: 20px;\n            color: #555;\n            font-size: 14px;\n            text-decoration: none;\n          }\n\n          > .active {\n            background: #fff;\n          }\n        }\n\n        > .user {\n          margin-top: 5px;\n        }\n      }\n    }\n  }\n"])), MEDIA_QUERIES.PC_TABLET, MEDIA_QUERIES.PHONE);
var MenuStatus;
(function (MenuStatus) {
    MenuStatus["Visible"] = "visible";
    MenuStatus["Hidden"] = "hidden";
})(MenuStatus || (MenuStatus = {}));
var Menu = posed.div({
    enter: {
        left: 0,
        delay: 200,
        transition: {
            left: { ease: "easeOut", duration: 300 },
        },
    },
    exit: {
        left: "100%",
        transition: {
            left: { ease: "easeOut", duration: 300 },
        },
    },
});
var Dimmed = posed.div({
    enter: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        transition: {
            backgroundColor: { ease: "easeOut", duration: 200 },
        },
    },
    exit: {
        backgroundColor: "rgba(0, 0, 0, 0)",
        transition: {
            backgroundColor: { ease: "easeOut", duration: 200 },
        },
    },
});
var MobileHeader = /** @class */ (function (_super) {
    __extends(MobileHeader, _super);
    function MobileHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            menu: MenuStatus.Hidden,
        };
        _this.setMenu = function (menu) {
            _this.setState({
                menu: menu,
            });
        };
        return _this;
    }
    MobileHeader.prototype.renderAnotherAppLink = function (project) {
        switch (project) {
            case "mohyun":
                return React.createElement(Link, { to: "/bmntech" }, "BM&Tech");
            case "bmntech":
                return React.createElement(Link, { to: "/mohyun" }, "\uBAA8\uD604\uC528\uC564\uB514");
        }
    };
    MobileHeader.prototype.componentDidUpdate = function () {
        switch (this.state.menu) {
            case MenuStatus.Visible: {
                document.querySelector("body").classList.add("block-scroll");
                break;
            }
            case MenuStatus.Hidden: {
                document.querySelector("body").classList.remove("block-scroll");
                break;
            }
        }
    };
    MobileHeader.prototype.render = function () {
        var _this = this;
        var _a = this.props, project = _a.project, url = _a.url;
        var menu = this.state.menu;
        return (React.createElement(Query, { query: GET_HEADER, variables: { projectName: project } }, function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            if (loading)
                return React.createElement(Loading, null);
            if (error)
                return React.createElement(Error, null);
            return (React.createElement(Container, null,
                React.createElement("div", { className: "logo" },
                    React.createElement(Link, { to: url },
                        React.createElement("img", { src: data.project.logoUrl }))),
                React.createElement("div", { className: "menu-btn", onClick: function () { return _this.setMenu(MenuStatus.Visible); } },
                    React.createElement("img", { src: "https://s3.ap-northeast-2.amazonaws.com/garen-s3-bucket/mohyun/icon_menu.png" })),
                React.createElement(PoseGroup, null, menu === MenuStatus.Visible && [
                    React.createElement(Dimmed, { key: "dimmed", className: "dimmed" }),
                    React.createElement(Menu, { key: "menu", className: "menu", onClick: function () { return _this.setMenu(MenuStatus.Hidden); } },
                        React.createElement("div", { className: "area", onClick: function (e) { return e.stopPropagation(); } },
                            React.createElement("div", { className: "x", onClick: function () { return _this.setMenu(MenuStatus.Hidden); } },
                                React.createElement("img", { src: "https://s3.ap-northeast-2.amazonaws.com/garen-s3-bucket/mohyun/icon_x_on_menu.png" })),
                            React.createElement("nav", { onClick: function () { return _this.setMenu(MenuStatus.Hidden); } },
                                React.createElement(NavLink, { to: "" + url, exact: true, activeClassName: "active" }, "\uD648"),
                                React.createElement(NavLink, { to: url + "/introduce", activeClassName: "active" }, "\uD68C\uC0AC\uC18C\uAC1C"),
                                React.createElement(NavLink, { to: url + "/technology", activeClassName: "active" }, "\uBCF4\uC720\uAE30\uC220"),
                                React.createElement(NavLink, { to: url + "/products", activeClassName: "active" }, "\uC601\uC5C5\uD488\uBAA9"),
                                React.createElement(NavLink, { to: url + "/guide", activeClassName: "active" }, "\uCDE8\uAE08\uC81C\uD488 \uC124\uBA85 \uC790\uB8CC"),
                                React.createElement(NavLink, { to: url + "/database", activeClassName: "active" }, "\uC790\uB8CC\uC2E4"),
                                React.createElement(NavLink, { to: url + "/customer", activeClassName: "active" }, "\uACE0\uAC1D\uC9C0\uC6D0"),
                                _this.renderAnotherAppLink(project)),
                            React.createElement("div", { className: "user", onClick: function () { return _this.setMenu(MenuStatus.Hidden); } },
                                React.createElement(User, { url: url })))),
                ])));
        }));
    };
    return MobileHeader;
}(React.Component));
export default MobileHeader;
var templateObject_1;
